import 'css-chunksrc/client/scenes/resourceEdition/allocationManagement/resource/styles.scss';export default {
  "resource": "_resource_19f3n_1",
  "icon": "_icon_19f3n_26",
  "removeResourceIconContainer": "_removeResourceIconContainer_19f3n_38"
};